import React, { useEffect } from 'react';
import $i18n from '@alife/panda-i18n';
import { CnTab, CnTabItem, CnTextEllipsis } from '@alife/cn-ui';
// @ts-ignore
import { logCustom } from 'src/utils/tracker';
import { PanelType } from 'src/types';
import SearchInput from 'src/view/components/search-input';
import './index.scss';
import { handleCustomMatchUrl, matchPageByUrl } from 'src/utils';
const matchQuestion = (pages, defaults, lang) => {
    const pathname = location.pathname;
    const includesPage = pages?.filter((p) => {
        // @ts-ignore
        return window.cnIntelliAssistantFilterUrl ? handleCustomMatchUrl(p?.pageUrl, pathname) : matchPageByUrl(p?.pageUrl, pathname);
    });
    if (includesPage?.length > 0) {
        return includesPage;
    }
    else {
        const defaultPage = defaults?.filter((p) => p?.language === lang);
        return defaultPage;
    }
};
const CN = $i18n?.getLang() || 'zh-CN';
function setDefaultLanguage(list, lang = CN) {
    list?.forEach?.((item) => {
        if (!item.language) {
            item.language = lang;
        }
    });
}
export default function HotQuestion(props) {
    const { panelConfig, panelCode, currentHotTab, setCurrentHotTab } = props;
    const hostConfig = panelConfig?.find((m) => m?.panelConfigCode === PanelType.hotQuestion);
    // 处理默认语言 兼容性未来可能出现的兼容问题
    setDefaultLanguage(hostConfig?.data?.pageHotQuestion);
    setDefaultLanguage(hostConfig?.data?.defaultHotQuestion);
    const currentLang = CN;
    const questionData = matchQuestion(hostConfig?.data?.pageHotQuestion, hostConfig?.data?.defaultHotQuestion, currentLang);
    useEffect(() => {
        if (questionData) {
            logCustom('EXP_hotQuestion', questionData, panelCode);
        }
    }, []);
    if (!questionData)
        return null;
    return (React.createElement("div", { className: "cn-intelli-assistant-hot-question" },
        React.createElement(SearchInput, { className: "cn-intelli-assistant-hot-question-search", readOnly: true, onClick: () => {
                props?.onItemClick?.(PanelType.hotQuestionSearch);
                logCustom(`CLK_${PanelType.hotQuestionSearch}`, '', props.panelCode);
            } }),
        React.createElement(CnTab, { className: "cn-intelli-assistant-hot-question-tab", defaultActiveKey: currentHotTab, onChange: setCurrentHotTab, shape: "wrapped", excessMode: "dropdown", tabPosition: "top" }, questionData?.map((m, i) => {
            return (React.createElement(CnTabItem, { key: i, title: m?.guideText },
                React.createElement("ul", { className: 'cn-intelli-assistant-hot-question-area' }, m?.knowledgeQuestionList?.map((l, i) => {
                    let newTitle = null;
                    if (i <= 2) {
                        newTitle = (React.createElement("div", { className: "cn-intelli-assistant-hot-question-hot-item" },
                            React.createElement("span", { className: "cn-intelli-assistant-hot-question-hot-before" }, i + 1),
                            React.createElement(CnTextEllipsis, { line: 2 }, l?.knowledgeName)));
                    }
                    else {
                        newTitle = (React.createElement("div", { className: "cn-intelli-assistant-hot-question-hot-item" },
                            React.createElement("span", { className: "cn-intelli-assistant-hot-question-hot-after" }, i + 1),
                            React.createElement(CnTextEllipsis, { line: 2 }, l?.knowledgeName)));
                    }
                    return (React.createElement("li", { className: "cn-intelli-assistant-hot-question-hot-list", key: l?.knowledgeId + '-' + i, onClick: () => {
                            props?.onItemClick?.(PanelType.hotQuestion, l.knowledgeId);
                            logCustom(`CLK_${PanelType.hotQuestion}`, l.knowledgeId, props.panelCode);
                        } }, newTitle));
                }))));
        }))));
}
